import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import {
  resetStatDataAction,
  resetStatisticsDataset,
  resetStatSelectsAction,
  resetToolbarSelect,
} from 'store/actions/mainPage';
import {
  resetATEAction,
  resetFoundLayerAction,
  setCurrentLayerAction,
  setDefaultLayerAction,
} from 'store/actions/layers';
import { getText } from 'services/languageService';
import { SearchLayersBlock } from 'components/SearchTab/SearchLayersBlock';
import { BusinessEntityBlock } from 'components/SearchTab/BusinessEntityBlock';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';

enum SearchTypes {
  LAYERS = 'layers',
  BE = 'business_entity',
}

export const SearchTab: React.FC = () => {
  const [searchType, setSearchType] = useState<string>(SearchTypes.LAYERS);
  const dispatch = useAppDispatch();
  const { lang } = useAppSelector((state) => state.mainPage);
  const handleChange = (event: SelectChangeEvent) => {
    setSearchType(event.target.value);
  };

  const resetLayerData = () => {
    // dispatch(setCurrentLayerAction('', '', 0, '', '', ''));
    dispatch(resetATEAction());
    dispatch(setDefaultLayerAction(0));
    dispatch(resetFoundLayerAction());
  };

  useEffect(() => {
    resetLayerData();
    dispatch(resetStatDataAction());

    return () => {
      resetLayerData();
    };
  }, [searchType]);

  useEffect(() => {
    dispatch(resetStatSelectsAction()); //reset statistics selects
    dispatch(resetStatisticsDataset());

    return () => {
      dispatch(resetToolbarSelect());
    };
  }, []);

  return (
    <Box>
      <FormControl fullWidth size="small" sx={{ p: '16px 16px 0 16px' }}>
        <Select
          labelId="demo-select-small-label"
          id="demo-select-small"
          value={searchType}
          onChange={handleChange}
          key={lang}
        >
          <MenuItem value={SearchTypes.LAYERS}>
            {getText('SEARCH_TYPE_LAYERS')}
          </MenuItem>

          <MenuItem value={SearchTypes.BE}>
            {getText('SEARCH_TYPE_BE')}
          </MenuItem>
        </Select>
      </FormControl>
      {searchType === SearchTypes.LAYERS ? (
        <SearchLayersBlock />
      ) : (
        <BusinessEntityBlock />
      )}
    </Box>
  );
};
